import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-brand-navy text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-white text-lg font-normal tracking-wide mb-4">
              Light Chasing Adventures
            </h3>
            <p className="text-sm leading-relaxed text-gray-400 max-w-md">
              We follow the light — when it dances in the sky, and when it shapes the land.
            </p>
            <div className="flex items-center space-x-4 mt-6">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="mailto:hello@lightchasingadventures.com" className="text-gray-400 hover:text-white transition-colors">
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-medium tracking-wide mb-4">Explore</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/northern-lights" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Northern Lights
                </Link>
              </li>
              <li>
                <Link to="/northern-lights-tromso" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Tromso September
                </Link>
              </li>
              <li>
                <Link to="/seasonal-adventures" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Seasonal Adventures
                </Link>
              </li>
              <li>
                <Link to="/philosophy" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Philosophy
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-medium tracking-wide mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">
                hello@lightchasingadventures.com
              </li>
              <li className="text-sm text-gray-400">
                Based in the UK
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Light Chasing Adventures. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;